// Which files a batch assignment takes — the trainer's reference files and the
// student's work alike. Twin of vc_be/utils/generalAssignmentFiles.js: the same
// extensions, limits and wording, pinned by both test files. Change both.
//
// The browser can only judge a file by its name and size; the server also reads
// its bytes, so a renamed file is still refused there, by name.

export const MAX_FILE_MB = 10;
export const MAX_FILES = 5;

export const ACCEPTED_EXTENSIONS = [
  "pdf", "doc", "docx", "xls", "xlsx", "csv", "ppt", "pptx", "txt", "jpg", "jpeg", "png", "webp",
];

/** For `<input accept>` / `FileUpload accept`. */
export const ACCEPT = ACCEPTED_EXTENSIONS.map((ext) => `.${ext}`).join(",");

export const ACCEPTED_LABEL = "PDF, Word, Excel, CSV, PowerPoint, text or an image (JPG, PNG, WebP)";

/** The short line under a drop zone. */
export const ACCEPTED_HINT = `PDF, Word, Excel, CSV, PowerPoint, text or images · up to ${MAX_FILE_MB} MB each`;

export const extensionOf = (name) => {
  const base = String(name || "");
  const dot = base.lastIndexOf(".");
  return dot > 0 ? base.slice(dot + 1).toLowerCase() : "";
};

/** The reason a picked file cannot be attached, or null. */
export function fileProblem(file) {
  const name = file?.name || "This file";
  if (!ACCEPTED_EXTENSIONS.includes(extensionOf(file?.name))) {
    return `"${name}" can't be attached. Use a ${ACCEPTED_LABEL}.`;
  }
  if (!file.size) return `"${name}" is empty.`;
  if (file.size > MAX_FILE_MB * 1024 * 1024) return `"${name}" is larger than ${MAX_FILE_MB} MB.`;
  return null;
}
